/**
 * Yan menu ogelerinin tur isaretleri. Her menu ogesi (alt menudekiler dahil)
 * `data-tour="menu:<sayfa yolu>"` tasir. Yan menu modul ayarlarina ve role gore
 * suzuldugu icin karsilama turu, bir sayfanin kullaniciya acik olup olmadigini
 * bu isaretten anlar (ayni ayarlari ikinci kez sunucudan istemeden).
 */

/** Menu ogesinin `data-tour` degeri: sayfa yolu (bastaki `/` ve sorgu olmadan). */
export const menuItemTourId = (pathKey: string) => `menu:${pathKey}`;

const MENU_ITEM_SELECTOR = '[data-tour^="menu:"]';

/**
 * Sayfa yan menude var mi? Menu hic cizilmemisse (ogeler bulunamazsa) sayfa
 * acik kabul edilir; o durumda tur, sayfanin basligi gorunmezse sayfayi atlar.
 */
export const isPageInMenu = (pathKey: string, root: ParentNode = document) =>
    !root.querySelector(MENU_ITEM_SELECTOR) || Boolean(root.querySelector(`[data-tour="${menuItemTourId(pathKey)}"]`));
